import { enumerable } from '@Common/Core/CoreDecorator';

export interface ITabItem {
    disabled?: boolean;
    id?: string;
    name?: string;
    content?: any;
    refresh?: () => any;
    isActive?: boolean;
    icon?: string;
    tooltip?: string;
    allowClose?: boolean;
    className?: string;
    itemDefaultStyle?: string;
    itemHoverStyle?: string;
    itemSelectedStyle?: string;
}

export class TabItem {
    private spinner?: JQuery<HTMLElement>;

    constructor(public readonly li: JQuery, public readonly item: ITabItem, public readonly name: JQuery, public readonly icon?: JQuery) {}

    public destroy(): void {
        this.li.remove();
        if (this.content.getControl) {
            this.content.getControl()?.remove();
        } else if (this.content.remove) {
            this.content.remove();
        }

        if (this.icon) {
            this.icon.remove();
        }

        if (this.name) {
            this.name.remove();
        }
    }

    @enumerable
    get id(): string {
        return this.item.id;
    }

    @enumerable
    get content() {
        return this.item.content;
    }

    public enabled(enabled: boolean): void {
        this.item.disabled = !enabled;
        this.li.toggleClass('disabled', !enabled);
    }

    public setName(newName: string, tooltip?: string): void {
        this.item.name = newName;
        this.li.attr('title', tooltip || newName);
        this.li.find('.name').text(newName);
    }

    public spinnerStart(): void {
        this.icon?.hide();

        // create spinner
        const spinnerHolder = this.spinner || $('<div class="loader-holder"/>').prependTo(this.li);
        const spinnerSize = this.li.height();
        spinnerHolder.outerHeight(spinnerSize);
        spinnerHolder.outerWidth(spinnerSize);
        spinnerHolder.spinnerStart({
            showBackground: false,
            isSmall: true
        });

        this.spinner = spinnerHolder;
    }

    public spinnerStop(): void {
        this.icon && this.icon.show();
        this.spinner && this.spinner.remove();
        this.spinner = null;
    }

    public setError(msg: string): void {
        this.li.addClass('invalid');
        this.li.attr('title', msg);
    }

    public removeError(): void {
        this.li.removeClass('invalid');
        this.li.attr('title', '');
    }

    public visibility(visibility: boolean): void {
        this.li.toggleClass('hidden-tab', !visibility);
    }

    public getClientRect(): DOMRect {
        return this.li[0].getBoundingClientRect();
    }
}
